import { DatePipe } from '@angular/common';
import {Component} from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from 'ng2-charts';
import { filter } from 'rxjs/operators';
import { LoginService } from '../../login-service';
import { navItems, navItems1, navItems2 } from '../../_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  providers: [DatePipe]
})
export class DefaultLayoutComponent {
  public sidebarMinimized = false;
  public navItems = navItems;
  public navItems1 = navItems1;
  public navItems2 = navItems2;
  public display:any;
 public displaycollaborator=false;
 public displayinitiator=false;
 public displayadmin=false;
  usersList: any;
  userID: any;
  name: any;
  tempUsersList: any;
  url: any;
  userTypeName: string;
  signupdisplay: any;
  notificationsList: any;
  msgnotificationsList: any;
  tabValue1: number;
  userID1: any;
  subscriptionList: any;
  subscriptionid: any;
  typename: string;
  todaysDate: any;
 constructor(private loginService:LoginService,private router: Router,private datepipe:DatePipe)
 {
  this.url=this.loginService.imageURL;
   this.display=localStorage.getItem('LOGGEDINAS');
   this.signupdisplay=localStorage.getItem('SIGNEDUPAS')
   this.userTypeName=localStorage.getItem('userType');
   this.GetUsers();
   this.userID=localStorage.getItem('USERID');
   if(this.userTypeName=='2')
   {
     this.displaycollaborator=true;
     this.typename="Initiator";
   }
   else if(this.userTypeName=='1')
   {
    this.displayinitiator=true;
    this.typename="Collaborator";
   }
   else if(this.userTypeName=='3' || this.userTypeName=='4')
   {
     this.displayadmin=true;
   }
 }
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  ngOnInit(){
    var date=new Date();
   
    this.todaysDate = this.datepipe.transform(date, 'yyyy-MM-dd');
    console.log(this.todaysDate)
    this.GetNotifications();
    this.GetUsers();
  }
  GetNotifications(){
    this.loginService.GetNotifications().subscribe(data=>{
data = JSON.parse(data['_body']);
var tempNotifitaions=JSON.parse(JSON.stringify(data));
let fiterUserNotifications:any;
let notificatons:any;
//Message notifications
  fiterUserNotifications=tempNotifitaions.filter(c=>c.receiverUserid==this.userID && c.type.toString()=="message");
if(fiterUserNotifications.length>0){
  this.msgnotificationsList=fiterUserNotifications;
}
else{
  this.msgnotificationsList=[];
}
// Other Notifications
notificatons=tempNotifitaions.filter(c=>c.receiverUserid==this.userID && c.type.toString()!=="message");
if(notificatons.length>0){
 
  this.notificationsList=notificatons;
}
else{
  this.notificationsList=[];
}
    });
  }
  //Retrieving all users by usertype
  Switch(){
    this.userTypeName=localStorage.getItem('userType');
    if(this.userTypeName=='2')
    {
      this.typename="Initiator";
    }
    else if(this.userTypeName=='1')
    {
     this.typename="Collaborator";
    }
  }
  switchaccount()
  {
    setTimeout(() => {
      this.GetUsers()
     }, 1000);
     var userid=localStorage.getItem("USERID");
    if (this.usersList.length > 0) {
       let validateUser = this.usersList.filter(x=>x.id.toString()==userid.toString());
       let validateemail=this.usersList.filter(x=>x.email.toString()==validateUser[0].email.toString());
       if(validateUser[0].user_type_id==1){this.tabValue1=2;localStorage.setItem("userType","2");}
       else if(validateUser[0].user_type_id==2){this.tabValue1=1;localStorage.setItem("userType","1");}
       const jsonData = {
        firstnameparm:validateUser[0].first_name,
    lastnameparm:validateUser[0].last_name,
    usernameparm:validateUser[0].first_name+" "+validateUser[0].last_name,
    emailparm:validateUser[0].email,
    passwordparm:validateUser[0].password,
    usertypeidparm:this.tabValue1,
    isverifiedparam:'y',
    socialusersparm:"",
    issubscribedparam:"n"
      };
      if(validateemail.length==2)
      {
        this.loginService.GetSubscriptions().subscribe(data=>{
          data = JSON.parse(data['_body']);
          let useridd=validateemail.filter(x=>x.id!==validateUser[0].id)
          this.subscriptionList=JSON.parse(JSON.stringify(data));
          let filteredsubscription = this.subscriptionList.filter(x=>(x.collaborator_id==useridd[0].id)||(x.initiator_id==useridd[0].id));
          console.log(filteredsubscription[0])
        localStorage.setItem("USERID",useridd[0].id)
        if(validateUser[0].user_type_id==1 && useridd[0].issubscribed=='y'&&this.todaysDate<=filteredsubscription[0].end_date.split('T')[0])
        {
          this.typename="Collaborator";
          localStorage.setItem("userType","2");
          this.displaycollaborator=true;
          this.displayinitiator=false;
          localStorage.setItem("LOGGEDINAS","Collaborator")
        this.router.navigate(['/collabo']);
       
        }
        else if(validateUser[0].user_type_id==2 && useridd[0].issubscribed=='y'&&this.todaysDate<=filteredsubscription[0].end_date.split('T')[0])
        {
          this.typename="Initiator";
          localStorage.setItem("userType","1")
          this.displayinitiator=true;
          this.displaycollaborator=false;
          localStorage.setItem("LOGGEDINAS","Initiator")
          this.router.navigate(['/initatorcollabo/0/0'])
        }
        else{
          this.router.navigate(['/subscribe', useridd[0].id, useridd[0].user_type_id,0]);
        }
        this.userID=useridd[0].id;
        this.GetUsers();
        this.GetNotifications();
        return;
      });
      }
      else{
      if(validateUser[0].email)
      this.loginService.SaveUsers(jsonData).subscribe(data=>{
        this.userID1=data['_body'].toString();
        this.loginService.GetSubscriptions().subscribe(data=>{
          data = JSON.parse(data['_body']);
          this.subscriptionList=JSON.parse(JSON.stringify(data));
          let filteredsubscription = this.subscriptionList.filter(x=>(x.collaborator_id==this.userID)||(x.initiator_id==this.userID));
          this.userID=this.userID1
          this.GetUsers();
          this.GetNotifications();
         this.router.navigate(['/subscribe', this.userID1, this.tabValue1,0]);
         
      });
      })
    }
    }
  }
  GetUsers(){
    this.loginService.GetUsers(this.userTypeName).subscribe(data=>
      {
        
        data = JSON.parse(data['_body']);
              this.usersList=JSON.parse(JSON.stringify(data));
              for(let i=0;i<this.usersList.length;i++)
              {
              if(this.userID==this.usersList[i].id)
              {
                this.name=this.usersList[i].first_name;
              }
            }
            let filterUser=this.usersList.filter(x=>x.id.toString()==this.userID.toString());
if(filterUser.length>0){
this.tempUsersList=filterUser[0];
if(this.tempUsersList.Profile!==null ){
this.url=this.loginService.imageURL;
}
else if(this.tempUsersList.Profile===null ){
this.url="";
this.tempUsersList.Profile='/assets/images/user.png';
}
}
      });
  }

}
